import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { GoogleRecaptchaIosSettings } from "./app-settings-config-google-ios-recaptcha";

export interface IGoogleRecaptchaIosInputState {
  showModal: boolean;
  googleRecaptchaIosSettingsId: string;
}

export interface IGoogleRecaptchaIosInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class GoogleRecaptchaIosInput extends PureComponent<
  IGoogleRecaptchaIosInputProps,
  IGoogleRecaptchaIosInputState
> {
  formInputName = ["iosConfig", "googleRecaptchaIosSettingsId"];

  constructor(props: IGoogleRecaptchaIosInputProps) {
    super(props);
    this.state = {
      showModal: false,
      googleRecaptchaIosSettingsId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, googleRecaptchaIosSettingsId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ googleRecaptchaIosSettingsId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [...(commonSettings.googleRecaptchaIosSettings || [])];

    return (
      <>
        <GoogleRecaptchaIosSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingGoogleRecaptchaIosSettingsId={this.state.googleRecaptchaIosSettingsId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey="iosconfig_googlerecaptcha_configuration"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="iosGoogleRecaptchaConfigDropdown"
          addNewTestId="iosGpsTrackerConfigurationAddNewButton"
          editTestId="iosGoogleRecaptchaConfigurationEditButton"
        />
      </>
    );
  }
}
